import moment from "moment";
import { useEffect, useState } from "react";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getRulesetByIdAsync, updateRulesetAsync } from "../../Helpers/API/RulesetApi";
import RulesetForm from "./RulesetForm";

const UpdateRuleset = () => {
	const navigate = useNavigate();
	const { id } = useParams();

	const [formValues, setFormValues] = useState({
		name: "",
		sourceSystem: "",
		pathwayId: "",
		order: 0,
		rules: [],
		expiryDate: "",
		deactivateSurveysOnExpiry: true,
	});

	const onSubmit = (rulesetObject) => {
		async function updateRuleset() {
			const ruleset = rulesetObject;

			if (ruleset.expiryDate === "" || ruleset.expiryDate === null || ruleset.expiryDate === undefined) {
				ruleset.expiryDate = null;
				ruleset.deactivateSurveysOnExpiry = null;
			}

			const success = await updateRulesetAsync(id, ruleset);
			if (success) navigate("/rulesets");
		}
		updateRuleset();
	};

	useEffect(() => {
		async function getRule() {
			const { name, sourceSystem, pathwayId, order, rules, expiryDate, deactivateSurveysOnExpiry } = await getRulesetByIdAsync(id);

			const expiryDateString = expiryDate === null ? "" : moment(expiryDate).format("YYYY-MM-DD");
			const deactivateSurveysOnExpiryValue = deactivateSurveysOnExpiry === null ? true : deactivateSurveysOnExpiry;
			setFormValues({
				name,
				sourceSystem,
				pathwayId,
				order,
				rules,
				expiryDate: expiryDateString,
				deactivateSurveysOnExpiry: deactivateSurveysOnExpiryValue,
			});
		}
		getRule();
	}, [id]);

	return (
		<div>
			<div className="breadcrumbs">
				<Breadcrumb>
					<Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
						Home
					</Breadcrumb.Item>
					<Breadcrumb.Item linkAs={Link} linkProps={{ to: "/rulesets" }}>
						Rulesets
					</Breadcrumb.Item>
					<Breadcrumb.Item active>Update Ruleset</Breadcrumb.Item>
				</Breadcrumb>
			</div>
			<RulesetForm initialValues={formValues} saveText="Update ruleset" headerText="Update an existing ruleset" onSubmit={onSubmit} isUpdateMode />
		</div>
	);
};

export default UpdateRuleset;
